import request from "./requestLongTimeOut.js";

export default function getBatchDetail(access_token, batch_id) {
  return request({
    url: "/batch",
    method: "get",
    headers: {
      access_token,
    },
    params: {
      batch_id,
    },
  });
}
